import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=516d61ca&scoped=true&"
import script from "./brands.vue?vue&type=script&lang=js&"
export * from "./brands.vue?vue&type=script&lang=js&"
import style0 from "./brands.vue?vue&type=style&index=0&id=516d61ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d61ca",
  null
  
)

export default component.exports